<section *ngIf="message || errors.length > 0" class="app-error-summary" role="alert" aria-live="assertive">
    <h2 *ngIf="title" class="app-error-summary__title">{{ title | translate }}</h2>
    <p *ngIf="message" class="app-error-summary__message">{{ message | translate }}</p>
    <ul *ngIf="errors.length > 0" class="app-error-summary__list">
        <li *ngFor="let item of errors">{{ item.message | translate }}</li>
    </ul>
</section>
